import apiService from "../../../../../service/Api";
import { toast } from "react-toastify";
import { IComment } from "../../../../../types/comment";

export const handleBulkAction = async (
  bulkSelectAction: React.RefObject<string>,
  checkedCommentsID: string[],
  renderingComments: IComment[],
  setRenderingComments: React.Dispatch<React.SetStateAction<IComment[]>>,
  fetchComments: (initialFetch: boolean) => Promise<void>
) => {
  const action = bulkSelectAction.current;

  if (checkedCommentsID.length === 0) {
    toast.warning(`Please select comments for bulk action`, {
      position: "top-right",
      autoClose: 5000,
      theme: "light",
    });
    return;
  }

  const ids = checkedCommentsID.map((id) => Number(id));

  try {
    await apiService.post(`/api/chats/memorial-message/bulk-${action}/`, {
      message_ids: ids,
    });

    // change the isApproved for all comments if all were selected
    if (checkedCommentsID.length === renderingComments.length) {
      const newComments = renderingComments.map((comment: IComment) => {
        return {
          ...comment,
          isApproved: action === "approve" ? true : false,
        };
      });

      setRenderingComments([...newComments]);
      fetchComments(false);
    }

    // else just change for the selected ones

    if (checkedCommentsID.length !== renderingComments.length) {
      const renderingCommentsMirror = [...renderingComments];
      const checkedComments: IComment[] = [];

      checkedCommentsID.forEach((commentID) => {
        const comment: IComment | undefined = renderingComments.find(
          (comment) => comment.id === commentID
        );
        if (comment) {
          checkedComments.unshift(comment);
        }
      });

      const newComments = checkedComments.map((comment: IComment) => {
        return {
          ...comment,
          isApproved: action === "approve" ? true : false,
        };
      });

      newComments.forEach((comment) => {
        const index = renderingCommentsMirror.findIndex(
          (renderingComment) => renderingComment.id === comment.id
        );

        if (index !== -1) {
          renderingCommentsMirror[index] = comment;
        }
      });

      setRenderingComments([...renderingCommentsMirror]);
      fetchComments(false);
    }

    toast.success(`Comments ${action}`, {
      position: "top-right",
      autoClose: 5000,
      theme: "light",
    });
  } catch (error) {
    console.error(error);
    toast.error("Failed to update status.Please try again", {
      position: "top-right",
      autoClose: 5000,
      theme: "light",
    });
  } finally {
    //setIsStatusUpdating(false);
  }
};
